import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

const styles = {
  attachmentContainer: css`
    @media (max-width: ${breakpoints.small.min}px) {
      margin-bottom: ${theme.spacing(2)};
    }
  `,
};

interface Props {
  attachment: string;
  onClick: () => void;
  skipAttachmentAuth?: boolean;
}

export const OpenAttachmentButton = ({ attachment, skipAttachmentAuth = false, onClick }: Props) => {
  const { t } = useTranslation('weave-pay');
  return (
    <form
      method='post'
      action={skipAttachmentAuth ? attachment : undefined}
      target={skipAttachmentAuth ? '_blank' : ''}
      onSubmit={(e) => !skipAttachmentAuth && e.preventDefault()}
    >
      <Button
        iconName='preview'
        type='submit'
        css={styles.attachmentContainer}
        onClick={() => !skipAttachmentAuth && onClick()}
        variant='secondary'
      >
        {t('View Invoice')}
      </Button>
    </form>
  );
};
